<template>
  <div>
    <b-table
      :items="tableItems"
      :fields="tableFields"
      responsive="sm"
      class="cartTable"
    >
      <template #cell(product)="data">
        <div class="d-flex align-items-center">
          <img
            :src="
              data.item.images
                ? data.item.images.smallImage
                : data.item.imageLink
            "
            alt="Product Image"
            class="table-product-image img-fluid"
          />
          <div>
            <div class="product-name">
              <!-- <pre>{{ data }}</pre> -->
              {{
                data.item.description_summary &&
                data.item.description_summary.length > 20
                  ? data.item.Name
                  : data.item.description_summary
              }}
            </div>
            <div
              class="product-brand"
              v-if="data.item._id != '67f0bd1458eeb6f746342b34'"
            >
              {{ data.item.Brand }}
            </div>
          </div>
        </div>
      </template>

      <template #cell(price)="data">
        <h6 class="text-icon price-normal mb-0">
          {{ currency.symbol }}{{ Number(data.item.Price).toFixed(2) }}
          {{ currency.code }}
        </h6>
      </template>

      <template #cell(quantity)="data">
        <checkout-increment-decrement
          :callCheckout="true"
          :cartItem="data.item"
        />
      </template>
      <template #cell(total)="data">
        <!-- <span class="mdi mdi-currency-usd text-icon price">
        {{ data.item.unitAmount }}
      </span> -->
        <h6 class="text-icon price-normal mb-0">
          {{ currency.symbol }}{{ Number(data.item.unitAmount).toFixed(2) }}
          {{ currency.code }}
        </h6>
      </template>
      <template #cell(action)="data">
        <button
          class="remove-btn"
          @click="removeItemFromCart(data)"
          v-if="data.item._id != '67f0bd1458eeb6f746342b34'"
        >
          <b-icon-x-circle></b-icon-x-circle>
        </button>
      </template>
    </b-table>
    <!-- Mobile View -->
    <div class="mobile-cart-view d-md-none">
      <div class="mobile-cart-item" v-for="item in tableItems" :key="item._id">
        <!-- PRODUCT -->
        <div class="mobile-row">
          <div class="mobile-label">{{ $t("cartItem.product") }}</div>
          <div class="mobile-value d-flex align-items-center">
            <img
              :src="item.images ? item.images.smallImage : item.imageLink"
              alt="Product Image"
              class="table-product-image"
            />
            <div class="ml-2">
              <div class="product-name">
                {{
                  item.description_summary &&
                  item.description_summary.length > 20
                    ? item.Name
                    : item.description_summary
                }}
              </div>
              <div
                class="product-brand"
                v-if="item._id !== '67f0bd1458eeb6f746342b34'"
              >
                {{ item.Brand }}
              </div>
            </div>
          </div>
        </div>

        <!-- PRICE -->
        <div class="mobile-row">
          <div class="mobile-label">{{ $t("cartItem.price") }}</div>
          <div class="mobile-value text-icon price-normal mb-0">
            {{ currency.symbol }} {{ Number(item.Price).toFixed(2) }}
            {{ currency.code }}
          </div>
        </div>

        <!-- QUANTITY -->
        <div class="mobile-row">
          <div class="mobile-label">{{ $t("cartItem.quantity") }}</div>
          <div class="mobile-value quantityDelete">
            <checkout-increment-decrement
              :callCheckout="true"
              :cartItem="item"
            />
            <button
              class="remove-btn"
              @click="removeItemFromCart({ item })"
              v-if="item._id !== '67f0bd1458eeb6f746342b34'"
            >
              <b-icon-archive></b-icon-archive>
            </button>
          </div>
        </div>

        <!-- SUB TOTAL -->
        <div class="mobile-row">
          <div class="mobile-label">{{ $t("cartItem.subTotal") }}</div>
          <div class="mobile-value text-icon price-normal mb-0">
            {{ currency.symbol }}{{ Number(item.unitAmount).toFixed(2) }}
            {{ currency.code }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "cart-item",
  props: {
    cartItem: {
      default: () => {},
      type: Object,
    },
    callCheckout: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      cartData: (state) => state.checkout.cartData,
      currency: (state) => state.home.currency,
    }),
    tableItems() {
      return this.cartData.map((item) => ({
        ...item,
      }));
    },
  },
  data() {
    return {
      tableFields: [
        {
          key: "product",
          label: this.$t("cartItem.product"),
          class: "text-left",
        },
        {
          key: "price",
          label: this.$t("cartItem.price"),
          class: "text-center",
        },
        {
          key: "quantity",
          label: this.$t("cartItem.quantity"),
          class: "text-center",
        },
        {
          key: "total",
          label: this.$t("cartItem.subTotal"),
          class: "text-center",
        },
        {
          key: "action",
          label: this.$t("cartItem.action"),
          class: "text-center",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    async removeItemFromCart(data) {
      if (data.item._id == "67f0bd1458eeb6f746342b34") {
        this.$toasted.info(this.$t("cartItem.deliveryChargeError"));
        return;
      }
      await this.$store.dispatch("checkout/removeItem", {
        cartItem: data.item,
        callApi: true,
      });
      if (this.$route.name == "checkout")
        await this.$store.dispatch("checkout/removeItem", {
          cartItem: { _id: "67f0bd1458eeb6f746342b34" },
          callApi: true,
        });
      await this.$store.dispatch("checkout/checkoutFinal");
    },
  },
};
</script>
<style scoped>
.card-img-left {
  border-top-left-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
  margin: 5px;
  height: 120px;
  width: 120px;
  object-fit: contain;
}

.card-text-main {
  font-size: 18px;
  line-height: 20px;
}
.card-text-sub {
  font-size: 16px;
  line-height: 10px;
  color: #a4a4a4;
  margin-left: 2px;
}
.card-text-price {
  font-size: 26px;
  line-height: 30px;
}
.order-provider-tag {
  font-size: 14px;
}
.order-provider-name {
  font-size: 14px;
  text-decoration-line: underline;
  color: #3977d3;
}
.card {
  border: none;
  font-weight: 500;
  font-style: normal;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-bottom-color: rgba(0, 0, 0, 0.125);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-image: initial initial initial;
}
::v-deep.cartTable table {
  border: 1px solid #ddd;
  border-radius: 8px;
}
::v-deep.cartTable .b-table th {
  border-bottom: none;
  border-top: none;
}
::v-deep.cartTable .b-table tr th div {
  font-size: 0.875rem;
  font-weight: 500;
}
::v-deep.cartTable .b-table tr td {
  vertical-align: middle;
}
@media (max-width: 768px) {
  .inc-dec-mobile-view {
    margin-bottom: 15px;
  }
}
.table-product-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-right: 10px;
  text-align: center;
}

.product-name {
  font-size: 16px;
  font-weight: 400;
}

.product-brand {
  font-size: 14px;
  color: #a4a4a4;
}

.price {
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .table-product-image {
    width: 50px;
    height: 50px;
  }

  .product-name {
    font-size: 14px;
  }

  .price {
    font-size: 16px;
  }
}
.table-product-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-right: 10px;
  text-align: center;
}

.product-name {
  font-size: 16px;
  font-weight: 400;
}

.product-brand {
  font-size: 14px;
  color: #a4a4a4;
}

.price {
  font-size: 14px;
  font-weight: 500;
}

/* Mobile Styles */
@media (max-width: 767.98px) {
  .table-product-image {
    width: 50px;
    height: 50px;
  }

  .product-name {
    font-size: 14px;
  }

  .price {
    font-size: 16px;
  }

  .mobile-cart-view {
    display: block;
  }

  .mobile-cart-item {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
    background-color: #fff;
  }

  .mobile-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .mobile-label {
    font-weight: 600;
    color: #333;
    width: 35%;
    font-size: 14px;
  }

  .mobile-value {
    width: 65%;
    font-size: 14px;
    text-align: left;
  }
  .quantityDelete {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .quantityDelete .remove-btn {
    color: red;
    font-size: 18px;
  }
  ::v-deep .incre-decre-wrapper {
    justify-content: flex-start !important;
  }
  ::v-deep.cartTable table {
    display: none !important;
  }
}
</style>
